import React from 'react'
import { Cell } from 'fixed-data-table-2'

/**
 * @typedef {object} CheckboxCellProps
 * @property {number|null} [rowIndex]
 * @property {object} definition
 * @property {Array} [data]
 * @property {Function} toggle
 * @property {boolean} [disabled]
 */
import { CheckboxField } from '@adc/ui-core'
import classnames from 'classnames/bind'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

const CheckboxCell = _props => {
  const {
    rowIndex = null,
    definition,
    data = [],
    toggle,
    disabled = false, // eslint-disable-line no-unused-vars
    ...props
  } = _props

  const handleToggle = () => {
    toggle(rowIndex, definition.field)
  }

  const { field } = definition
  const baseField = field.substring(field.lastIndexOf('.') + 1)
  const row = data[rowIndex]
  return (
    <Cell className={cx('cell', 'checkbox-cell')} {...props}>
      <CheckboxField
        checkboxLabel={'\x00'} // force semantic to pick up clicks outside checkbox but inside cell
        elmId={`select_${rowIndex}`}
        checked={row[baseField]}
        onChange={handleToggle}
        disabled={row.error}
      />
    </Cell>
  )
}

export default CheckboxCell
